export default {
  SET_SELECTIONS: (state, { selections }) => {
    state.selections = selections;
  },
  SET_DIRECTION: (state, { direction }) => {
    state.direction = direction;
  },
  SET_RAIL_POSITION: (state, { railPosition }) => {
    state.railPosition = railPosition;
  },
  SET_LOADING_STATUS: state => {
    state.isLoading = !state.isLoading;
  },
  SET_SLIDERS: (state, { sliders }) => {
    state.sliders = sliders;
  },
  SET_LOGIN_STATUS: (state, { isLoggedIn }) => {
    state.isLoggedIn = isLoggedIn;
  },
  SET_PRESET_DATA: (state, { presetData }) => {
    state.presetData = presetData;
  },
  SET_MODAL_STATUS: (state, { showModal }) => {
    state.showModal = showModal;
  },
  SET_SELECTED_PRESET_ID: (state, { id }) => {
    state.selectedPresetId = id;
  },
};
